import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const DEFAULT_FAQS = [
    {
        id: 101,
        question: "How long does shipping and delivery take?",
        answer: "Orders are processed within 24 hours. Delivery usually takes 3 to 5 business days depending on your location across India."
    },
    {
        id: 102,
        question: "Is Cash on Delivery (COD) available?",
        answer: "Yes! We offer Cash on Delivery (COD) across all major pin codes in India."
    },
    {
        id: 103,
        question: "How can I track my order?",
        answer: "Once your order is dispatched, you will receive a tracking link via SMS/Email. You can also view live tracking from your Account Orders section."
    },
    {
        id: 104,
        question: "What is the return and refund policy?",
        answer: "We offer a 7-day hassle-free return/exchange policy for damaged or defective items. Please contact our support team to initiate a return."
    },
    {
        id: 105,
        question: "Are Bhabhuti Herbal products 100% natural and safe?",
        answer: "Yes, all Bhabhuti Herbal formulations are made with 100% pure Ayurvedic and natural herbal ingredients, thoroughly tested for safety and quality."
    }
];

export const FaqPage = () => {
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [openIndex, setOpenIndex] = useState(0); // first item expanded by default

    useEffect(() => {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000/api';
        axios.get(`${apiUrl}/faq/public`)
            .then(res => {
                const list = res.data && res.data.data ? res.data.data : [];
                if (list.length > 0) {
                    setFaqs(list);
                } else {
                    setFaqs(DEFAULT_FAQS);
                }
                setLoading(false);
            })
            .catch(() => {
                setFaqs(DEFAULT_FAQS);
                setLoading(false);
            });
    }, []);

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const filteredFaqs = faqs.filter(f => 
        (f.question || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (f.answer || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="faq-page-wrapper" style={{ backgroundColor: '#F8FAFC', minHeight: '80vh', paddingBottom: '60px' }}>
            
            {/* Hero Header */}
            <div style={{
                background: 'linear-[#1E293B] linear-gradient(135deg, #1E293B 0%, #0F172A 100%)',
                color: '#FFFFFF',
                padding: '60px 20px',
                textAlign: 'center'
            }}>
                <div className="container" style={{ maxWidth: '800px' }}>
                    <span style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        padding: '6px 16px',
                        borderRadius: '20px',
                        fontSize: '13px',
                        fontWeight: '600',
                        letterSpacing: '1px',
                        textTransform: 'uppercase',
                        color: '#6EE7B7',
                        display: 'inline-block',
                        marginBottom: '12px'
                    }}>
                        Customer Support & Help
                    </span>
                    <h1 style={{ fontSize: '36px', fontWeight: '800', marginBottom: '16px' }}>
                        Frequently Asked Questions
                    </h1>
                    <p style={{ fontSize: '16px', color: '#94A3B8', marginBottom: '28px' }}>
                        Have questions about ordering, shipping, payments, or returns? We're here to help.
                    </p>

                    {/* Search Input */}
                    <div style={{ position: 'relative', maxWidth: '600px', margin: '0 auto' }}>
                        <input
                            type="text"
                            placeholder="Search your question (e.g. shipping, COD, return)..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '14px 20px 14px 48px',
                                borderRadius: '12px',
                                border: 'none',
                                outline: 'none',
                                fontSize: '15px',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                                color: '#0F172A',
                                backgroundColor: '#FFFFFF'
                            }}
                        />
                        <i className="fa-solid fa-magnifying-glass" style={{
                            position: 'absolute',
                            left: '18px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#64748B',
                            fontSize: '16px'
                        }}></i>
                        {searchTerm && (
                            <i 
                                className="fa-solid fa-xmark" 
                                onClick={() => setSearchTerm('')}
                                style={{
                                    position: 'absolute',
                                    right: '18px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#64748B',
                                    fontSize: '16px',
                                    cursor: 'pointer'
                                }}
                            ></i>
                        )}
                    </div>
                </div>
            </div>

            {/* Content Container */}
            <div className="container" style={{ maxWidth: '850px', marginTop: '40px', padding: '0 20px' }}>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '50px 0' }}>
                        <div className="spinner-border text-primary" role="status"></div>
                        <p style={{ marginTop: '12px', color: '#64748B' }}>Loading FAQs...</p>
                    </div>
                ) : filteredFaqs.length === 0 ? (
                    <div style={{
                        backgroundColor: '#FFFFFF',
                        borderRadius: '16px',
                        padding: '40px 20px',
                        textAlign: 'center',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                        border: '1px solid #E2E8F0'
                    }}>
                        <i className="fa-regular fa-folder-open" style={{ fontSize: '40px', color: '#CBD5E1', marginBottom: '12px' }}></i>
                        <h4 style={{ fontSize: '18px', fontWeight: '700', color: '#1E293B' }}>No questions found</h4>
                        <p style={{ fontSize: '14px', color: '#64748B', marginBottom: '20px' }}>
                            We couldn't find any questions matching "{searchTerm}".
                        </p>
                        <button 
                            onClick={() => setSearchTerm('')}
                            style={{
                                padding: '8px 20px',
                                borderRadius: '8px',
                                backgroundColor: '#0F172A',
                                color: '#FFFFFF',
                                border: 'none',
                                fontWeight: '600',
                                fontSize: '13px'
                            }}
                        >
                            View All FAQs
                        </button>
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                        {filteredFaqs.map((faq, idx) => {
                            const isOpen = openIndex === idx;
                            return (
                                <div 
                                    key={faq.id || idx}
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: '14px',
                                        border: isOpen ? '1px solid #3B82F6' : '1px solid #E2E8F0',
                                        boxShadow: isOpen ? '0 4px 14px rgba(59, 130, 246, 0.08)' : '0 2px 6px rgba(0,0,0,0.02)',
                                        overflow: 'hidden',
                                        transition: 'all 0.2s ease-in-out'
                                    }}
                                >
                                    <button
                                        onClick={() => toggleFaq(idx)}
                                        style={{
                                            width: '100%',
                                            padding: '20px 24px',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                            outline: 'none',
                                            textAlign: 'left',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <span style={{
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            color: isOpen ? '#1D4ED8' : '#0F172A',
                                            paddingRight: '16px',
                                            lineHeight: '1.4'
                                        }}>
                                            {faq.question}
                                        </span>
                                        <div style={{
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            backgroundColor: isOpen ? '#EFF6FF' : '#F1F5F9',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0,
                                            color: isOpen ? '#1D4ED8' : '#64748B',
                                            transition: 'transform 0.2s ease'
                                        }}>
                                            <i className={`fa-solid ${isOpen ? 'fa-minus' : 'fa-plus'}`} style={{ fontSize: '13px' }}></i>
                                        </div>
                                    </button>

                                    {isOpen && (
                                        <div style={{
                                            padding: '0 24px 20px 24px',
                                            fontSize: '14px',
                                            color: '#334155',
                                            lineHeight: '1.7',
                                            borderTop: '1px solid #F1F5F9',
                                            paddingTop: '16px'
                                        }}>
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* Contact Banner at bottom */}
                <div style={{
                    marginTop: '50px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '16px',
                    padding: '32px 24px',
                    textAlign: 'center',
                    border: '1px solid #E2E8F0',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.03)'
                }}>
                    <h3 style={{ fontSize: '20px', fontWeight: '800', color: '#0F172A', marginBottom: '8px' }}>
                        Still have questions?
                    </h3>
                    <p style={{ fontSize: '14px', color: '#64748B', marginBottom: '24px' }}>
                        Can't find the answer you're looking for? Please contact our friendly support team.
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        <Link 
                            to="/contact-us"
                            className="btn"
                            style={{
                                backgroundColor: '#0F172A',
                                color: '#FFFFFF',
                                fontWeight: '600',
                                padding: '10px 24px',
                                borderRadius: '10px',
                                fontSize: '14px'
                            }}
                        >
                            <i className="fa-regular fa-envelope" style={{ marginRight: '8px' }}></i> Contact Us
                        </Link>
                        <a 
                            href="https://wa.me/918078609131?text=Hello%20Bhabhuti%20Herbal,%20I%20have%20a%20question."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn"
                            style={{
                                backgroundColor: '#25D366',
                                color: '#FFFFFF',
                                fontWeight: '600',
                                padding: '10px 24px',
                                borderRadius: '10px',
                                fontSize: '14px'
                            }}
                        >
                            <i className="fa-brands fa-whatsapp" style={{ marginRight: '8px' }}></i> WhatsApp Support
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
};
